import React, { Component } from "react";
import styled from "styled-components";
import ImageSlide from "./ImageSlide";
import NukaCarousel from "nuka-carousel";

const Wrapper = styled.section`
  width: 100%;
  height: 75vh;
  background-size: cover;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 90%);
  ::before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 10%,
      rgba(255, 255, 255, 0) 40%,
      rgba(0, 0, 0, 0) 40%,
      rgba(0, 0, 0, 0.7) 100%
    );
    z-index: 1;
  }
`;

const ChildWrapper = styled.div`
  position: absolute;
`;

class Carousel extends Component {
  mapImages = () =>
    this.props.images.map(({ image, imageDescription, id }, index) => {
      return <ImageSlide key={id} image={image} alt={imageDescription} />;
    });

  render() {
    const { children } = this.props;

    return (
      <Wrapper>
        <NukaCarousel autoplay wrapAround withoutControls heightMode="current">
          {this.mapImages()}
        </NukaCarousel>
        <ChildWrapper>{children}</ChildWrapper>
      </Wrapper>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel/index.js